import styled, { css } from 'styled-components'

type ColProps = {
  width: number
  gutter?: number
}

export const Col = styled.div<ColProps>`
  flex: 0 0 ${({ width }) => width}%;
  width: ${({ width }) => width}%;

  ${({ gutter }) => gutter && css`
    margin-left: ${gutter}%;
  `}
`
